import React, { Component } from 'react';
import {Header, NavbarInstance} from './Header';
import Terminal from './Modal';

class App extends Component {
  componentDidMount() {
        document.title = "Krishnakant Mishra - Resume built on React";
      }
  render() {
    return (
      
      <div className="App">
          <Header/>
          <Terminal/>
          <NavbarInstance/>
          {/*<GitNav NavTexts={['Google', 'Facebook']} NavURLs={['http://google.com','http://facebook.com']} /> */}
      </div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js